import { currentEnvironment } from '../services/Environment';
import { REGIONS } from './region.constants';

// Dev-only overrides so a second web/back-office instance can target a
// port-offset e2e stack running alongside the dev backend (PLT-4443). Wired
// through the vite `define` blocks (web + back-office); other bundlers resolve
// them to undefined and fall back to the standard localhost ports.
const devApiBaseURL = process.env.REACT_APP_DEV_API_BASE_URL || 'http://localhost:3600/';
const devAssetsBaseURL = process.env.REACT_APP_DEV_ASSETS_BASE_URL || 'http://localhost:4500/';

const backendServicebaseURLsMap = {
  [REGIONS.US]: {
    development: devApiBaseURL,
    staging: 'https://api.staging.app.c8health.com/',
    production: 'https://api.app.c8health.com/',
  },
  [REGIONS.EU]: {
    development: 'http://localhost:3555/',
    staging: 'https://api.staging.eu.c8health.com/',
    production: 'https://api.eu.c8health.com/',
  },
};

const assetsServiceBaseURLsMap = {
  [REGIONS.US]: {
    development: devAssetsBaseURL,
    staging: 'https://assets.staging.app.c8health.com/',
    production: 'https://assets.app.c8health.com/',
  },
  [REGIONS.EU]: {
    development: 'http://localhost:4555/',
    staging: 'https://assets.staging.eu.c8health.com/',
    production: 'https://assets.eu.c8health.com/',
  },
};

// Document Editor server is only supported in US region
const documentEditorServerURLsMap = {
  [REGIONS.US]: {
    development: 'http://localhost:8080',
    staging: 'https://editor.staging.app.c8health.com',
    production: 'https://editor.app.c8health.com',
  },
};

const appUrls = {
  development: 'http://localhost:3000/',
  staging: 'https://staging.app.c8health.com/',
  production: 'https://app.c8health.com/',
};

// BaseURLs
export const getBaseURL = (region = REGIONS.US) => {
  const validRegion = REGIONS[region] ?? REGIONS.US;
  return backendServicebaseURLsMap[validRegion][currentEnvironment()];
};
export const getAssetsServiceBaseURL = (region = REGIONS.US) => {
  const validRegion = REGIONS[region] ?? REGIONS.US;
  return assetsServiceBaseURLsMap[validRegion][currentEnvironment()];
};
export const getDocumentEditorServerURL = (region = REGIONS.US) => {
  const validRegion = REGIONS[region] ?? REGIONS.US;
  const regionConfig = documentEditorServerURLsMap[validRegion];
  // Return null if document editor is not supported in this region
  if (!regionConfig) return null;
  return regionConfig[currentEnvironment()];
};

// panda-service AG-UI streaming chat. Panda is on its own subdomain, US-only (no
// per-region map); the auth cookie rides a credentialed request to it. Local dev
// has no ingress prefix.
const pandaServiceBaseURLsMap = {
  development: 'http://localhost:8000/v1/',
  staging: 'https://panda.staging.app.c8health.com/api/v1/',
  production: 'https://panda.app.c8health.com/api/v1/',
};

export const getPandaStreamURL = () => `${pandaServiceBaseURLsMap[currentEnvironment()]}threads`;

export const appURL = appUrls[currentEnvironment()];
export const AUTHENTICATION_SERVICE_URL = 'v1/authentication/';
export const BIOMETRIC_SERVICE_URL = 'v1/authentication/biometric/';
export const USER_SERVICE_URL = 'v1/user/';
export const ORGANIZATION_SERVICE_URL = 'v1/organizations/';
export const KNOWLEDGE_SERVICE_URL = 'v1/knowledge/';
export const LAB_SERVICE_URL = 'v1/lab/';
export const ADMISSION_SERVICE_URL = 'v1/admission/';
export const OWNERS_SERVICE_URL = 'v1/owners/';
export const COMMUNICATION_SERVICE_URL = 'v1/communication/';
export const FAVORITES_SERVICE_URL = 'v1/user/favorites/';
export const DASHBOARD_SERVICE_URL = 'v1/dashboard/';
export const CONTACT_SERVICE_URL = 'v1/contact/';
export const LABEL_SERVICE_URL = 'v1/labels/';
export const ASSIGNMENT_SERVICE_URL = 'v1/assignment/';
export const ROTATION_SERVICE_URL = 'v1/rotation/';
export const WORKSPACE_SERVICE_URL = 'v1/workspace/';
export const ZEUS_SERVICE_URL = 'v1/zeus/';
export const ANALYTICS_SERVICE_URL = 'v1/analytics/';
export const HUB_SERVICE_URL = 'v1/hub/';
export const QUALITY_METRICS_SERVICE_URL = 'v1/quality-metric/';
export const SCHEDULE_SERVICE_URL = 'v1/schedules/';
export const DOCUMENT_EDITOR_SERVICE_URL = 'v1/document-editor/';
export const STAFF_SERVICE_URL = 'v1/staff/';
export const PROFILE_FIELDS_SERVICE_URL = 'v1/profile-fields/';
export const SEARCH_SYNONYMS_SERVICE_URL = 'v1/internal/search/synonyms/';

export const KNOWLEDGE_STORAGE_URL = 's3.eu-central-1.amazonaws.com/';
